module.exports = __webpack_public_path__ + "static/media/line-bg2.1b9810cf.png";